import React from 'react';
import Theme from 'Theme/index';
import { View, Text, Pressable } from 'react-native';
import { Icon, Hr } from 'LocalGluons/index';
// eslint-disable-next-line import/no-unresolved
import { ConsentDefinition } from 'types';
import portraitStyles, { landscapeStyles } from './VoyoConsentItemjss';
import { parseURLString, renderLinks } from '../../ParseUrlString/parseURLString';
import { WebLink } from '../WebLink';

interface VoyoConsentsItemProps {
    item: ConsentDefinition;
    isLandscape?: boolean;
    isSelected: boolean;
    onSelectedPress: (boolean) => void;
}

const VoyoConsentItem = ({
    isLandscape,
    item,
    isSelected,
    onSelectedPress
}: VoyoConsentsItemProps): JSX.Element => {
    const { consentText, order } = item;
    const styles = isLandscape ? landscapeStyles : portraitStyles;

    const handleClick = () => {
        onSelectedPress(order);
    };

    return (
        <View style={styles.itemContainer}>
            <View style={styles.itemInnerContainer}>
                <Pressable onPress={handleClick}>
                    <View
                        style={[
                            styles.itemButtonContainer,
                            {
                                backgroundColor: isSelected
                                    ? Theme.primaryButtonBackgroundColor
                                    : 'transparent'
                            }
                        ]}
                    >
                        {isSelected && (
                            <View style={styles.selectedConsent}>
                                <Icon style={styles.iconPosition} name="checkmark" />
                            </View>
                        )}
                    </View>
                </Pressable>

                <View style={styles.textContainer}>
                    <Text style={styles.consentText}>{renderLinks(consentText)}</Text>
                </View>
            </View>
            <View style={styles.lineWrapper}>
                <Hr />
            </View>
        </View>
    );
};

export default VoyoConsentItem;
